import { gql } from '@apollo/client';

export const PATCH_PROXY_OBJECT = gql`
    mutation patchProxyObject( $input: PatchProxyObjectInput! ) {
        result: patchProxyObject( input:$input ) {
            id
            fieldData
            companyIntegrationId
        }
    }
`;